
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mob/online-truck-booking",
      function () {
        return require("private-next-pages/mob/online-truck-booking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mob/online-truck-booking"])
      });
    }
  